/**
 * 个股详情页面顶部Header
 */
import React, { useEffect, useState } from "react"
import { HeaderSearch } from "../icon"
import { StockHeaderComputer } from "../header_computer"
import { HeaderBackBtn, StockMoreHeaderBackBtn } from "../header_back"
import "./index.less"
import { quotedata } from "../quotedata"
import { StockNameZoom } from "../quotedata/index"
import { ExpandName } from "../quotedata/expand_name"
import { getHeaderLabel } from "../utils"
import { PageType } from "../pagetype"
import { getStockDetailData } from "../../../modules/quote/web"
import { DelayTips } from "../delay_tips"
import { CommonTips } from "../../page/tips/common_tips"

export function StockHeader(props: { quotedata: quotedata; detail_data: any; pagetype: PageType }) {
  return (
    <>
      <div className="wrap-stock-header">
        <div className="comm-nav">
          <div className="back-btn">
            <HeaderBackBtn />
          </div>
          <div className={`comm-tit ${StockNameZoom(props.quotedata.name.substring(0, 12))}`}>
            <div className="title">
              <span>{props.quotedata.name.substring(0, 12)}</span>
              <ExpandName detail_data={props.detail_data} />
            </div>
            <div className="title">
              <span>{props.quotedata.code}</span>
              <DelayTips pagetype={props.pagetype} />
              <HeaderLabel data={props.detail_data} pagetype={props.pagetype} />
            </div>
          </div>
          <div className="search">
            <StockHeaderComputer quoteCode={props.quotedata.quotecode} />
            <span className="wrap-search">
              <HeaderSearch />
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export function StockMoreHeader(props: { quotedata: quotedata }) {
  const [detailData, setDetailData] = useState(undefined)

  useEffect(() => {
    ;(async () => {
      let data = await getStockDetailData(props.quotedata.quotecode, "f734")
      setDetailData(data)
    })()
  }, [])

  return (
    <>
      <div className="wrap-stock-header">
        <div className="comm-nav">
          <div className="back-btn-more">
            <StockMoreHeaderBackBtn market={props.quotedata.market} code={props.quotedata.code} />
          </div>
          <div className="comm-tit">
            <div className="title">
              <span>{props.quotedata.name}</span>
              <ExpandName detail_data={detailData} />
            </div>
            <div className="title">
              <span>{props.quotedata.code}</span>
            </div>
          </div>
          <div className="wrap-stockmore-search">
            <HeaderSearch />
          </div>
        </div>
      </div>
    </>
  )
}

export function HeaderLabel(props: { data: any; pagetype: PageType }) {
  const [tipsVisible, setTipsVisible] = useState(false)
  const [tipsContent, setTipsContent] = useState("")

  let labelArr: Array<string> = []
  if (props.data) {
    let arr = getHeaderLabel(props.data.f177)
    if (props.pagetype == PageType.沪深A股) {
      if (props.data.f107 == 1 && props.data.f111 == 23) {
        if (props.data.f107 == 1 && props.data.f182 == 33) {
          //科创板CDR
          arr.unshift("科创板CDR")
        } else {
          arr.unshift("科创板")
        }
      }
      if (props.data.f107 == 0 && (props.data.f181 & 2048)) {
        arr.unshift("京")
      }
      if ((props.data.f107 == 155 || props.data.f107 == 156) && props.data.f181 & 1) {
        //沪伦通GDR
        arr.push("沪伦通GDR")
      }
      if (props.data.f107 == 1 && props.data.f182 == 31) {
        //沪伦通CDR
        arr.push("沪伦通CDR")
      }
      if (props.data.f294 == 1 && !(props.data.f107 == 0 && (props.data.f181 & 2048))) {
        // 注册
        arr.push("注")
      }
      if (props.data.f107 == 0 && props.data.f182 == 86) {
        //创业板CDR
        arr.push("创业板CDR")
      }
      if (props.data.f288 == 1) {
        // 未盈利
        arr.push("未盈利")
      }
      if (props.data.f293 == 1) {
        // 表决权
        arr.push("表决权")
      }
      if (props.data.f295 == 1) {
        // 协议控制
        arr.push("协议控制")
      }
    }

    labelArr = arr.slice(0, 3)
    
    if (props.data.f107 == 1 && props.data.f111 == 23) {
      if (props.data.f803 == 1) {
        labelArr.push("成1")
      } else if (props.data.f803 == 2) {
        labelArr.push("成")
      }
    }
  }

  const clickLabel = (label: string) => {
    if (label == "成") {
      setTipsVisible(true)
      setTipsContent("新注册科创成长层股票")
    } else if(label == "成1"){
      setTipsVisible(true)
      setTipsContent("存量科创成长层股票")
    }else{
      setTipsVisible(false)
      setTipsContent("")
    }
  }

  return (
    <>
      {labelArr.length > 0 &&
        props.pagetype != PageType.未知 &&
        labelArr.map((item: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <span className="stock-lbl" key={index} onClick={() => clickLabel(item)}>
                {item}
              </span>
              {tipsVisible && <CommonTips tips={tipsContent} onClose={() => setTipsVisible(false)} />}
            </React.Fragment>
          )
        })}
    </>
  )
}
